import { useParams } from 'react-router';

import { SuggestionDetail } from '@/features/feedback';

import styles from './SuggestionPage.module.css';

export function SuggestionPage() {
  const { suggestionId = '' } = useParams();
  return (
    <div className={styles.page}>
      <SuggestionDetail key={suggestionId} suggestionId={suggestionId} />
    </div>
  );
}
